export default "__VITE_ASSET__2c8e3f8c__"